export default function formDataToArray(formData) {
  if (typeof formData.entries !== 'function') {
    return [];
  }

  const entries = [...formData.entries()];

  return entries.filter((entry) => entry[1]);
}
